import React from 'react';
import {ReviewUnit} from "@onegovbugs/onegov-react-components";
import styles from "./ReviewUnitApplication.module.scss";

export const InterStateDecisionReviewUnit = ({props, importExportDetails, onEditUrl}) => {   
    return (
        <ReviewUnit
            title={"Interstate Person/Organisation"}
            onEdit={() => props.history.push({
                pathname: onEditUrl,
              })}  
        >
            <div className={`row ${styles.infoLine}`}>
                <div className={"col-12"}>
                    <div>
                        { importExportDetails.ieType === "Export" && 
                            <em>Provide details of interstate person or business to whom the animals will be exported?</em>
                        }                    
                        { importExportDetails.ieType === "Import" && 
                            <em>Provide details of interstate person or business from whom the animals will be imported?</em>
                        }                    
                    
                    </div>
                    <div className={styles.camelCase}>{importExportDetails.interStateDecisionAppType}</div>
                </div>        
            </div>
        </ReviewUnit>
      
    )
}